import { fetchGetStateByStateKey } from '@iwoca/lapi-client/edge';
import { useDashboard } from 'components/Dashboard/Dashboard.context';
import { TGetStateResponseData } from 'lendingApi/lapiOverrides.types';
import { useNavigate } from 'react-router-dom';
import { IwQueryClient } from 'store/IwQueryClient';
import { TSignupSteps } from 'types';
import { PATH_NAMES } from 'utils/routes/pathNames';

export const useContinueRedirect = () => {
  const navigate = useNavigate();
  const { redirectionId, setRedirectionId } = useDashboard();

  const getRedirectUrl = (applicationId: string, step?: TSignupSteps) =>
    step
      ? PATH_NAMES.newApplication({ step, applicationId })
      : PATH_NAMES.newApplicationStep1({ applicationId });

  const handleRedirect = async (stateKey: string, applicationId: string) => {
    setRedirectionId(stateKey);
    IwQueryClient.getOrCreate().invalidateQueries({
      queryKey: ['offers', applicationId],
    });

    try {
      const { data } = await fetchGetStateByStateKey({ stateKey });
      const state = data as TGetStateResponseData;
      const step = state.ui?.tip_latest_signup_step;
      navigate(getRedirectUrl(applicationId, step));
    } catch {
      // fallback to step 1 on error
      navigate(getRedirectUrl(applicationId));
    } finally {
      setRedirectionId();
    }
  };

  return { handleRedirect, getRedirectUrl, redirectionId };
};
